import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Stack, Text } from "@mantine/core";
import { DAYS } from "../datasets/days_available";
export const DaysAvailable = ({ style, daysAvailable = [], timesAvailable = [] }) => {
    return (_jsxs(Stack, { gap: "xs", children: [_jsx(Flex, { style: {
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    ...style
                }, children: DAYS.map((day) => {
                    const isAvailable = daysAvailable
                        ? daysAvailable
                            .map((availableDay) => availableDay.toUpperCase())
                            .includes(day.toUpperCase())
                        : false;
                    return (_jsx("div", { style: {
                            backgroundColor: isAvailable
                                ? "var(--mantine-color-red-5)"
                                : "var(--mantine-color-gray-4)",
                            height: "1.2rem",
                            width: "1.2rem",
                            paddingTop: "1px",
                            marginRight: "0.2rem",
                            color: "var(--mantine-color-white)",
                            borderRadius: "100%",
                            textAlign: "center",
                            fontSize: "smaller",
                            fontWeight: 800,
                            zIndex: 1
                        }, children: day[0] }, day));
                }) }), timesAvailable && timesAvailable?.length > 0 && (_jsx(Flex, { gap: "sm", children: _jsx(Text, { variant: "meta-strong", children: timesAvailable?.join(", ") }) }))] }));
};
